import { html } from 'onefold';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Breadcrumbs } from '../components/Breadcrumbs';

export function AppShell(content: Node): Node {
  return html`
    <div class="overlay" id="overlay"></div>
    <div class="app-shell">
      ${Sidebar()}
      ${Header()}
      <main class="content">
        ${Breadcrumbs()}
        ${content}
      </main>
    </div>
  `;
}
